module.exports = __webpack_public_path__ + "aa.no2.3fe8c6b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/aa.no2.jpg
// module id = S+V6
// module chunks = 0